import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row-end w-full mbottom-04" }
const _hoisted_2 = { class: "appointment-type-list-container" }
const _hoisted_3 = {
  key: 0,
  class: "mtop-06"
}
const _hoisted_4 = { class: "item-header w-full" }
const _hoisted_5 = { class: "item-center" }
const _hoisted_6 = { class: "mleft-05" }
const _hoisted_7 = { class: "item-center item-header-right" }
const _hoisted_8 = { class: "item-order flex-row" }
const _hoisted_9 = {
  id: "information",
  class: "flex-col"
}
const _hoisted_10 = { class: "appointment-type-settings mtop-10 w-full" }
const _hoisted_11 = { class: "flex-col" }
const _hoisted_12 = { class: "item-header" }
const _hoisted_13 = { class: "mtop-10" }
const _hoisted_14 = { class: "right-content" }
const _hoisted_15 = { class: "flex-col" }
const _hoisted_16 = { class: "item-header" }
const _hoisted_17 = { class: "mtop-10" }
const _hoisted_18 = { class: "right-content" }
const _hoisted_19 = { class: "item-header" }
const _hoisted_20 = { class: "mtop-10" }
const _hoisted_21 = { class: "item-comment" }
const _hoisted_22 = { class: "mbottom-10" }
const _hoisted_23 = {
  key: 0,
  class: "row-end"
}
const _hoisted_24 = { class: "txt-red font-s" }
const _hoisted_25 = {
  key: 0,
  class: "mtop-10"
}

import { ref, computed, watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import EsAppointmentTypeForm from '@/components/form/esAppointmentTypeForm.vue';
import { useAppUserStore } from '@/stores/appUser';
import { ApiError, ScheduleStatus, UpdateItemName } from '@/models/share.model';
import EsButtonIcon from '@/components/esButtonIcon.vue';
import { AppointmentColor, AppointmentTypeApi, AppointmentColorApi, AppointmentTypeRequest, AppointmentTypeResponse, PersonLightResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from "@/config/medserver-api.config";
import SharedService from '@/services/SharedService';
import { useToast } from 'primevue';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import ToggleSwitch from 'primevue/toggleswitch';
import Dropdown from 'primevue/dropdown';
import { reactive } from 'vue'
import esButton from '@/components/esButton.vue';
import { PInputNumber } from "@/config/primevue";
import Textarea from 'primevue/textarea';
import EsNameForm from '@/components/form/esNameForm.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'esAppointmentTypeSettings',
  props: {
    selectedInstituteId: {},
    baseAppointmentDuration: {},
    selectedHealthPro: {}
  },
  emits: ['appointmentTypeChanged'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const appUserStore = useAppUserStore();
const toast = useToast();
const emits = __emit;

const shortTypeList = ref<AppointmentTypeResponse[]>([]);
const appointmentTypeApi = new AppointmentTypeApi(medServerApiConfig);
const appointmentColorApi = new AppointmentColorApi(medServerApiConfig);
const isFormModalOpened = ref<boolean>(false);
const isNameFormOpened = ref<boolean>(false);

const currentAppointmentType = ref<AppointmentTypeResponse>({
    appointmentTypeId: '',
    name: '',
    duration: 1,
    order: 0,
    note: '',
    color: undefined,
    offline: ScheduleStatus.OFFLINE,
});

const updateName = ref<UpdateItemName>({
    itemUuid : '',
    name: ''
});

const originalDataMap = reactive<{ [key: string]: AppointmentTypeResponse }>({});
const isUpdateMap = reactive<{ [key: string]: boolean }>({});

const appointmentTypeOptions = [
  { label: t('settings.label.appointmentType.online'), value: ScheduleStatus.ONLINE },
  { label: t('settings.label.appointmentType.offlineStatus'), value: ScheduleStatus.OFFLINE },
  // ES-758 : wait when feature trusted patients available
  // { label: t('settings.label.appointmentType.patient'), value: ScheduleStatus.PATIENT },
];

const appointmentColors = ref<AppointmentColor[]>([]);

const defaultAppointmentColor = computed(() => appointmentColors.value.find(color => color.isDefault));

const getAppointmentColors = async () => {
    await appointmentColorApi.listAppointmentColors().then((response: AppointmentColor[]) => {
        appointmentColors.value = response;
    }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t(`error.${error.status}`)
        });
    });
};

const selectAppointmentColor = (appointmentType: AppointmentTypeResponse, uuid: string) => {
    appointmentType.color = appointmentColors.value.find(color => color.uuid === uuid);
    updateAppointmentType(appointmentType);
};

const appointmentChipStyle = (color?: AppointmentColor) => ({
    backgroundColor: color?.backgroundColor,
    borderLeftColor: color?.trimColor,
    color: color?.textColor,
});

const currInstituteUuid = computed(() => {
  if (props.selectedInstituteId) return props.selectedInstituteId;
  if (!appUserStore.currentHealthGroupMembership) {return "";}
  const currentIwr = appUserStore.currentHealthGroupMembership.instituteWithRole;
  return currentIwr.instituteWithRoleId;
});

const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});

const updateNameMethod = async (nameForm: string) => {
    updateName.value.name = nameForm;
    if (updateName.value.itemUuid) {
        const appointmentTypeRequest: AppointmentTypeRequest = {
            name : updateName.value.name
        }
        await appointmentTypeApi.updateAppointmentType({
            instituteId: currInstituteUuid.value,
            appointmentTypeId: updateName.value.itemUuid,
            appointmentTypeRequest: appointmentTypeRequest
        }).then(() => {
            toastSuccess(toast, {
                summary: t('common.toast.success.update'),
                detail:  t('settings.label.appointmentType.message.success.update')
            });
            isNameFormOpened.value = false;
            getAllAppointmentTypes();
            emits('appointmentTypeChanged');
        }).catch((error: ApiError) => {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: error.status ? t(`error.${error.status}`) : t('common.toast.error')
            });
            // Throw error to set at false the var __alreadyClicked in v-one-click directive
            throw error;
        });
    }
}

const closeNameFormModal = async (newName: string) => {
  isNameFormOpened.value = false;
  if (newName) {
    getAllAppointmentTypes();
    emits('appointmentTypeChanged');
  }
}

const openNameForm = (appointmentType: AppointmentTypeResponse) => {
    updateName.value.itemUuid = appointmentType.appointmentTypeId;
    updateName.value.name = appointmentType.name
    isNameFormOpened.value = true;
}

/**
 * Opens the form modal for adding a new appointment type.
 * Initializes a default appointment type and sets its order using the next available value.
 */
const openAddForm = async () => {
    currentAppointmentType.value = {
        appointmentTypeId: '',
        name: '',
        duration: 1,
        order: 0,
        note: '',
        color: defaultAppointmentColor.value,
        offline: ScheduleStatus.OFFLINE,
    };

    currentAppointmentType.value.order = await appointmentTypeApi.getNextOrder({instituteId: currInstituteUuid.value, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value });

    isFormModalOpened.value = true;
}

/**
 * Moves the appointment type down in the ordering list.
 * Swaps the current appointment type with the next one in the list and updates the backend.
 *
 * @param {AppointmentTypeResponse} appointmentType - The appointment type to move down.
 */
const downOrder = async (appointmentType: AppointmentTypeResponse) => {
    const indexToChange = shortTypeList.value.findIndex((item: AppointmentTypeResponse) => item.appointmentTypeId === appointmentType.appointmentTypeId);
    const currentType = shortTypeList.value[indexToChange];

    const indexNextToChange = shortTypeList.value.findIndex((item: AppointmentTypeResponse) => item.order === currentType.order + 1);
    const nextCurrentType = shortTypeList.value[indexNextToChange];

    currentType.order++;
    nextCurrentType.order--;


    const newShortTypeList = shortTypeList.value.slice(0, shortTypeList.value.length);
    newShortTypeList[indexToChange -1] = nextCurrentType;
    newShortTypeList[indexToChange] = currentType;

    await appointmentTypeApi.updateAppointmentTypeOrder({
        instituteId: currInstituteUuid.value,
        appointmentTypeOrderRequest: newShortTypeList
    }).then(() => {
        toastSuccess(toast, {
            summary: t('common.toast.success.update'),
            detail:  t('settings.label.appointmentType.message.success.update')
        });
        getAllAppointmentTypes();
    }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t(`error.${error.status}`)
        });
    });
}

/**
 * Moves the appointment type up in the ordering list.
 * Swaps the current appointment type with the previous one in the list and updates the backend.
 *
 * @param {AppointmentTypeResponse} appointmentType - The appointment type to move up.
 */
const upOrder = async (appointmentType: AppointmentTypeResponse) => {
    const indexToChange = shortTypeList.value.findIndex((item: AppointmentTypeResponse) => item.appointmentTypeId === appointmentType.appointmentTypeId);
    const currentType = shortTypeList.value[indexToChange];

    const indexNextToChange = shortTypeList.value.findIndex((item: AppointmentTypeResponse) => item.order === currentType.order -1);
    const nextCurrentType = shortTypeList.value[indexNextToChange];

    currentType.order--;
    nextCurrentType.order++;


    const newShortTypeList = shortTypeList.value.slice(0, shortTypeList.value.length);
    newShortTypeList[indexToChange -1] = nextCurrentType;
    newShortTypeList[indexToChange] = currentType;

    await appointmentTypeApi.updateAppointmentTypeOrder({
        instituteId: currInstituteUuid.value,
        appointmentTypeOrderRequest: newShortTypeList
    }).then(() => {
        toastSuccess(toast, {
            summary: t('common.toast.success.update'),
            detail:  t('settings.label.appointmentType.message.success.update')
        });
        getAllAppointmentTypes();
    }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t(`error.${error.status}`)
        });
    });

}

const closeFormModal = async (reload: boolean) => {
   if (reload) {
        reloadAfterCreateOrUpdate();
    }
    isFormModalOpened.value = false;
}

const updateAppointmentType = async (appointmentType: AppointmentTypeResponse) => {
    if (appointmentType && currInstituteUuid.value) {
        appointmentType = SharedService.cleanObject(appointmentType);
        const appointmentTypeRequest: AppointmentTypeRequest = { ...appointmentType, color: appointmentType.color?.uuid };
        if (appointmentTypeRequest.appointmentTypeId) {
            appointmentTypeRequest.name = undefined;
            await appointmentTypeApi.updateAppointmentType({
                instituteId: currInstituteUuid.value,
                appointmentTypeId: appointmentTypeRequest.appointmentTypeId,
                appointmentTypeRequest
            }).then(() => {
                toastSuccess(toast, {
                    summary: t('common.toast.success.update'),
                    detail:  t('settings.label.appointmentType.message.success.update')
                });

                reloadAfterCreateOrUpdate();
            }).catch((error: ApiError) => {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t(`error.${error.status}`)
                });
            });
        } else if (currentPersonId.value || props.selectedHealthPro?.id) {
            await appointmentTypeApi.addAppointmentType({
                instituteId: currInstituteUuid.value,
                appointmentTypeRequest,
                doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value
            }).then(() => {
                toastSuccess(toast, {
                    summary: t('common.toast.success.add'),
                    detail:  t('settings.label.appointmentType.message.success.add')
                });

                reloadAfterCreateOrUpdate();
            }).catch((error: ApiError) => {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t(`error.${error.status}`)
                });
            });
        }        
    }
}

const reloadAfterCreateOrUpdate = async () => {
    await getAllAppointmentTypes();
    emits('appointmentTypeChanged');
    isFormModalOpened.value = false;
    currentAppointmentType.value = {
        appointmentTypeId: '',
        name: '',
        duration: 1,
        order: 0,
        note: '',
        color: defaultAppointmentColor.value,
        offline: ScheduleStatus.OFFLINE,
    };
}

/**
 * Fetches all appointment types for the current institute and populates the local list.
 * Also initializes the update flags for each appointment type.
 */
const getAllAppointmentTypes = () => {
    if (currInstituteUuid.value && (currentPersonId.value || props.selectedHealthPro?.id)) {
        appointmentTypeApi.listAppointmentTypes({instituteId: currInstituteUuid.value, isSetting: true, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value}).then((response: AppointmentTypeResponse[]) => {
        shortTypeList.value = response;
        response.forEach(item => {
            isUpdateMap[item.appointmentTypeId] = true;
        });
    });
    }
}

/**
 * Cancels the editing of an appointment type and restores its original values.
 *
 * @param {AppointmentTypeResponse} appointmentType - The appointment type being edited.
 */
const cancelEdit = (appointmentType: AppointmentTypeResponse) => {
  const id = appointmentType.appointmentTypeId;
  if (originalDataMap[id]) {
    Object.assign(appointmentType, originalDataMap[id]);
  }
  isUpdateMap[id] = !isUpdateMap[id];
};

/**
 * Updates the active appointment type via the API and refreshes the list of appointment types.
 * 
 * @async
 * @function updateActiveAppointmentType
 * @param {AppointmentTypeResponse} appointmentType - The appointment type to update.
 * 
 * @throws {ApiError} Throws an error if the API call fails.
 * 
 * @description
 * - Cleans the `appointmentType` object before sending.
 * - If the object has an `appointmentTypeId`, calls the API to update the active type.
 * - Shows a success or error toast based on the API response.
 * - Reloads the list of appointment types by calling `getAllAppointmentTypes`.
 * - Emits the `appointmentTypeChanged` event.
 * - Resets `currentAppointmentType` to a default empty state.
 */
const updateActiveAppointmentType = async (appointmentType: AppointmentTypeResponse) => {
    if (appointmentType) {
        appointmentType = SharedService.cleanObject(appointmentType);
        if (appointmentType.appointmentTypeId) {
           await appointmentTypeApi.updateActiveAppointmentType(
                {
                    instituteId: currInstituteUuid.value,
                    appointmentTypeId: appointmentType.appointmentTypeId
                }
            ).then(() => {
                toastSuccess(toast, {
                    summary: t('common.toast.success.update'),
                    detail:  t('settings.label.appointmentType.message.success.update')
                });
            }).catch((error: ApiError) => {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t(`error.${error.status}`)
                });
            });
        } 
        getAllAppointmentTypes();
        emits('appointmentTypeChanged');
    }

    currentAppointmentType.value = {
        appointmentTypeId: '',
        name: '',
        duration: 1,
        order: 0,
        note: '',
        color: defaultAppointmentColor.value,
        offline: ScheduleStatus.OFFLINE,
    };
}

watch(
  () => currInstituteUuid,
  (newCurrInstituteUuid) => {
    if (newCurrInstituteUuid) {
        getAllAppointmentTypes();
    }
  },
  { deep: true }
);

watch(
  ()=> props.selectedHealthPro, 
  async  () => {
    await getAllAppointmentTypes();
  }
);

onMounted(() => {
    getAppointmentColors();
    if (currInstituteUuid.value) {
        getAllAppointmentTypes();
    }
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(esButton, {
        label: _unref(t)('action.add'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openAddForm())),
        "is-primary": true
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shortTypeList.value, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (shortTypeList.value && shortTypeList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "t-header" }, null, -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h2", _hoisted_6, _toDisplayString(item.name), 1),
                    _createVNode(EsButtonIcon, {
                      class: "mright-05 pad-m",
                      icon: "pencil_fill",
                      folder: "shareIcons",
                      styles: "img-grey",
                      onClick: ($event: any) => (openNameForm(item))
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(ToggleSwitch), {
                      modelValue: item.active,
                      onClick: ($event: any) => (updateActiveAppointmentType(item))
                    }, null, 8, ["modelValue", "onClick"]),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "rod" }, null, -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(EsButtonIcon, {
                        class: "mright-05",
                        icon: "chevron-compact-2-down",
                        folder: "shareIcons",
                        onClick: ($event: any) => (downOrder(item)),
                        disabled: item.order >= shortTypeList.value.length
                      }, null, 8, ["onClick", "disabled"]),
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "rod" }, null, -1)),
                      _createVNode(EsButtonIcon, {
                        class: "mleft-05",
                        icon: "chevron-compact-2-up",
                        folder: "shareIcons",
                        onClick: ($event: any) => (upOrder(item)),
                        disabled: item.order == 1
                      }, null, 8, ["onClick", "disabled"])
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('settings.label.appointmentType.duration')), 1),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('settings.label.appointmentType.durationUnit', { count: props.baseAppointmentDuration }),
                            disabled: true
                          }, null, 8, ["txt"]),
                          _createVNode(_unref(PInputNumber), {
                            modelValue: item.duration,
                            min: 1,
                            size: "small",
                            showButtons: "",
                            "onUpdate:modelValue": (value) => { item.duration = value; updateAppointmentType(item); }
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ])
                    ]),
                    _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "rod-horizontal" }, null, -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)('settings.label.appointmentType.fieldColor')), 1),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_unref(Dropdown), {
                            modelValue: item.color?.uuid,
                            "onUpdate:modelValue": (uuid) => selectAppointmentColor(item, uuid),
                            options: appointmentColors.value,
                            optionValue: "uuid",
                            class: "w-full"
                          }, {
                            value: _withCtx((slotProps) => [
                              (slotProps.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "appointment-chip",
                                    style: _normalizeStyle(appointmentChipStyle(appointmentColors.value.find(color => color.uuid === slotProps.value)))
                                  }, _toDisplayString(item.name), 5))
                                : _createCommentVNode("", true)
                            ]),
                            option: _withCtx((slotProps) => [
                              _createElementVNode("span", {
                                class: "appointment-chip",
                                style: _normalizeStyle(appointmentChipStyle(slotProps.option))
                              }, _toDisplayString(item.name), 5)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
                        ])
                      ])
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "rod-horizontal" }, null, -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)('settings.label.appointmentType.offline')), 1),
                      _createVNode(_unref(Dropdown), {
                        modelValue: item.offline,
                        "onUpdate:modelValue": ($event: any) => ((item.offline) = $event),
                        options: appointmentTypeOptions,
                        optionLabel: "label",
                        optionValue: "value",
                        class: "custom-input input-text-status",
                        onChange: () => updateAppointmentType(item)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "rod-horizontal" }, null, -1)),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(t)('settings.label.appointmentType.note')), 1),
                      _createVNode(_unref(Textarea), {
                        modelValue: item.note,
                        "onUpdate:modelValue": ($event: any) => ((item.note) = $event),
                        rows: "3",
                        autoResize: "",
                        onBlur: () => updateAppointmentType(item)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                    ]),
                    (item.note?.length >= 255)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(t)('settings.error.numberMaxChar')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 512), [
                  [_vShow, item.active]
                ]),
                (!isUpdateMap[item.appointmentTypeId])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(esButton, {
                        label: _unref(t)('action.update'),
                        onClick: ($event: any) => (updateAppointmentType(item)),
                        "is-primary": true
                      }, null, 8, ["label", "onClick"]),
                      _createVNode(esButton, {
                        label: _unref(t)('action.cancel'),
                        onClick: ($event: any) => (cancelEdit(item)),
                        class: "mleft-10",
                        "is-primary": false
                      }, null, 8, ["label", "onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _createVNode(EsAppointmentTypeForm, {
      selectedInstituteId: props.selectedInstituteId,
      selectedHealthProId: props.selectedHealthPro?.id ?? null,
      isOpen: isFormModalOpened.value,
      appointmentType: currentAppointmentType.value,
      onModalClose: _cache[1] || (_cache[1] = ($event: any) => (closeFormModal($event))),
      header: _unref(t)('settings.label.appointmentType.add.header')
    }, null, 8, ["selectedInstituteId", "selectedHealthProId", "isOpen", "appointmentType", "header"]),
    _createVNode(EsNameForm, {
      isOpen: isNameFormOpened.value,
      header: _unref(t)('settings.label.appointmentType.update.name'),
      label: _unref(t)('settings.label.appointmentType.name'),
      name: updateName.value.name,
      updateMethod: updateNameMethod,
      onModalClose: _cache[2] || (_cache[2] = ($event: any) => (closeNameFormModal($event)))
    }, null, 8, ["isOpen", "header", "label", "name"])
  ], 64))
}
}

})